module.exports = __webpack_public_path__ + "img/logo.6551dc7a.svg";